import { BucketDef } from './bucket-def';
import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';

export class ALMNSFRBucketing extends BaseBucketingStrategy implements BucketingStrategy {
    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs(): void {
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12, true), this.startOfNextBucket(), true, '1Y'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12 * 50, true), this.startOfNextBucket(), true, 'Longterm'));
    }

    strategyName(): string {
        return 'ALMNSFR';
    }

    getAllBucketTenors(): string[] {
        return this.bucketDefs
            .map((bd: BucketDef) => {
                if (bd.bucketName === 'Longterm') {
                    return '50Y';
                } else {
                    return bd.bucketName;
                }
            });
    }
}
